import BuscaObjetoPostal from '@base/Inputs/BuscaObjetoPostal/BuscaObjetoPostal';

export default BuscaObjetoPostal;